import { render, staticRenderFns } from "./order-return.vue?vue&type=template&id=3c8a3b0a&scoped=true"
import script from "./order-return.vue?vue&type=script&lang=js"
export * from "./order-return.vue?vue&type=script&lang=js"
import style0 from "./order-return.vue?vue&type=style&index=0&id=3c8a3b0a&prod&scoped=true&lang=css"
import style1 from "./order-return.vue?vue&type=style&index=1&id=3c8a3b0a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c8a3b0a",
  null
  
)

export default component.exports